/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_About_P3Inputs */

const en_vc_about_p3 = /** @type {(inputs: Vc_About_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not to be confused with other products that share the name, such as a Figma plugin for converting bitmaps to SVG or a web tool for animated SVG icons. This page is about the ArtCraft vector editor.`)
};

const zh_vc_about_p3 = /** @type {(inputs: Vc_About_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请不要和其他同名产品混淆，例如一款把位图转成 SVG 的 Figma 插件，或一个制作动态 SVG 图标的网页工具。本页介绍的是 ArtCraft 的矢量编辑器。`)
};

/**
* | output |
* | --- |
* | "Not to be confused with other products that share the name, such as a Figma plugin for converting bitmaps to SVG or a web tool for animated SVG icons. This p..." |
*
* @param {Vc_About_P3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_about_p3 = /** @type {((inputs?: Vc_About_P3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_About_P3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_about_p3(inputs)
	return zh_vc_about_p3(inputs)
});
export { vc_about_p3 as "vc.about.p3" }